<template>
  <custom-dialog width="850px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table index :data="tableList" tableCode="contract_device_list"></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="visible = false">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      formSearch: {
        customShipmentNum: '',
        pageSize: 20,
        pageNum: 1
      },
      tableList: [],
      totalRows: null
    };
  },
  mounted() {
    this.formSearch.customShipmentNum = this.model.customShipmentNum;
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.LogisticsDevicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    }
  }
};
</script>

<style lang="scss"></style>
